window.onload = function() {
  var YOUTUBE_API_KEY = "AIzaSyD9ZaOJbk95xelX5TG-eEDGhWn4iK-nuuc";
  [].forEach.call(document.getElementsByTagName('iframe'), function(e) {
    if (e.src && e.src.includes('youtube.com/embed/')) {
      var srcParts = (e.src).split('/');
      var id = srcParts[srcParts.length - 1];
      var url = "https://www.googleapis.com/youtube/v3/videos?part=snippet,contentDetails,statistics&id=" + id + "&key=" + YOUTUBE_API_KEY;
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
          var responseObject = JSON.parse(this.response);
          if (responseObject.items && responseObject.items.length > 0) {
            var video = responseObject.items[0];
            var jsonld = {
              "@context": "http://schema.org",
              "@type": "VideoObject",
              "name": video.snippet.title,
              "description": video.snippet.description,
              "thumbnailUrl": [
                video.snippet.thumbnails.default.url,
                video.snippet.thumbnails.medium.url,
                video.snippet.thumbnails.high.url,
                video.snippet.thumbnails.maxres ? video.snippet.thumbnails.maxres.url : ""
              ],
              "uploadDate": video.snippet.publishedAt,
              "contentUrl": "https://www.youtube.com/watch?v=" + video.id,
              "embedUrl": "https://www.youtube.com/embed/" + video.id,
              "duration": video.contentDetails.duration,
              "interactionStatistic": {
                "@type": "InteractionCounter",
                "interactionType": { "@type": "WatchAction" },
                "userInteractionCount": video.statistics.viewCount
              }
            };
            var el = document.createElement('script');
            el.type = 'application/ld+json';
            el.text = JSON.stringify(jsonld);
            document.querySelector('head').appendChild(el);
          } else {
            console.error('No video data found for ID:', id);
          }
        }
      };
      xhttp.open("GET", url, true);
      xhttp.send();
    }
  });
};

function addSwiperCssJs() {
  if(document.getElementById('swiper-js') == null){
    var script = document.createElement('script');
    script.setAttribute('src', window.theme.assets.swiperJS);
    script.id = 'swiper-js';
    document.head?.appendChild(script);
    var styles = document.createElement('link');
    styles.setAttribute('href', window.theme.assets.swiperCSS);
    styles.setAttribute('rel', 'stylesheet');
    document.head.appendChild(styles);
  }
}

window.klaviyoPublicKey = 'UNatcp';
window.addEventListener('DOMContentLoaded', function () {
  var swipers = document.querySelectorAll('[data-swiper-init]');
  const swiperObjs = [];

  function addSwiper(el) {
    addSwiperCssJs();
    var timeout = setInterval(function () {
      if (typeof Swiper != 'undefined') {
        clearInterval(timeout);
        initSwiper(el);
      }
    }, 100);
  }

  function initSwiper(el) {
    var optionsKey = el.dataset.swiperInit;
    if(!optionsKey){return}
    var options = window.swiperOptions[optionsKey];
    if(!options){return}
    var swiper = new Swiper(el, options);
    swiperObjs.push({key: 'swiper-' + optionsKey, slider: swiper, el: el, options: options});
    return swiper;
  }

  var swiperHandler = function (entries, observer) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      swiperObserver.unobserve(el);
      addSwiper(el);
    });
  }
  var swiperObserver = new IntersectionObserver(swiperHandler, { rootMargin: '400px 0px 400px 0px' });
  swipers.forEach(function (el) {
    swiperObserver.observe(el);
  });



  // Lazy load background images
  var bgHandler = function (entries, observer) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      bgObserver.unobserve(el);
      el.classList.remove('lazy-bg');
    });
  }
  var bgObserver = new IntersectionObserver(bgHandler,{rootMargin: '400px 0px 400px 0px'});
  var lazyBGs = document.querySelectorAll('.lazy-bg');
  lazyBGs.forEach(function(el){
    bgObserver.observe(el);
  });

  if (Shopify.designMode) {
    window.addEventListener('shopify:section:load', function (e) {
      var editorSwipers = document.querySelectorAll('[data-swiper-init]');
      editorSwipers.forEach(function (el) {
        addSwiper(el);
      });
      var editorLazyBGs = document.querySelectorAll('.lazy-bg');
      editorLazyBGs.forEach(function(el){
        el.classList.remove('lazy-bg');
      });
    });
  }

  // Generic toggle
  const togglers = document.querySelectorAll('.toggler')
  togglers.forEach(toggler => {
    toggler.addEventListener('click', () => {
      const parent = toggler.parentElement
      const lessText = toggler.dataset.less
      const moreText = toggler.dataset.moreText

      parent.classList.toggle('active')
      toggler.textContent = (parent.classList.contains('active') ? lessText : moreText)
    })
  })

  // Lazyload iframes
  var iframes = document.querySelectorAll('.iframe-lazy[data-src]');
  var iframeHandler = function (entries, observer) {
    entries.forEach((entry) => {
      var el = entry.target;
      if (!entry.isIntersecting) return;
      el.src = el.dataset.src;
      iframeObserver.unobserve(el);
    });
  }
  var iframeObserver = new IntersectionObserver(iframeHandler,{rootMargin: '400px 0px 400px 0px'});
  iframes.forEach((el) => {
    iframeObserver.observe(el);
  });

});
function swiperDestroy(el){
  var swiperId = el.getAttribute('swiper-id')
  var swiperOptionId = swiperId.replace('swiper-','')
  var swiper = document.getElementById(swiperId).swiper;
  var action = el.getAttribute('swiper-destroy')
  if (action == 'destroy') {
    swiper.destroy();
    el.setAttribute('swiper-destroy', 'init')
    el.textContent = 'Hide All'
  } else {
    const swiper = new Swiper('#'+swiperId, {
      slidesPerView: 7,
      slidesPerGroup: 7,
      spaceBetween: 6,
      grid: {
        rows: 2,
        fill: "row",
      },
      navigation: {
        nextEl: "#"+swiperId+" .swiper-button-next-swatch",
        prevEl: "#"+swiperId+" .swiper-button-prev-swatch",
      },
      pagination: {
        el: '#'+swiperId+' .product-carousel__pagination',
        type: 'bullets',
        clickable: true,
        bulletClass: 'product-carousel__pagination-bullet'
      }
    });

    el.setAttribute('swiper-destroy', 'destroy')
    el.textContent = 'View All'
  }
}
// Email Signup Popup
document.addEventListener('DOMContentLoaded', function() {
  var ynEmailPopup = null;

  function ynOpenEmailPopup() {
    ynInitEmailPopup();
    ynEmailPopup.classList.add('active');

    // Listen to the form submit event
    var klaviyoForm = document.getElementById('email_signup_popup');
    klaviyoForm.addEventListener('submit', function(event) {
      event.preventDefault();  // Prevent the form from submitting immediately

      // Manually submit the form using the custom submission function
      submitKlaviyoForm(klaviyoForm, () => {
        // Handle switching to the next step
        var nextStep = ynEmailPopup.querySelector(`.email-signup-popup__step[data-step="3"]`);
        if (nextStep) {
          var steps = ynEmailPopup.querySelectorAll('.email-signup-popup__step');
          steps.forEach((step) => {
            step.classList.add('hide');
          });
          nextStep.classList.remove('hide');
          nextStep.classList.add('fade-in');
          var focusable = nextStep.querySelectorAll('button, [href], input, select, textarea');
          if (focusable[0]) {
            focusable[0].focus();
          }
        } else {
          ynCloseEmailPopup();
        }
      })
    });
  }

  function ynCloseEmailPopup() {
    sessionStorage.setItem('ynEmailPopupClosed', 'true');
    ynEmailPopup.classList.remove('active');
  }

  function ynInitEmailPopup() {
    ynEmailPopup = document.getElementById('email-signup-popup');
    var closeButtons = ynEmailPopup.querySelectorAll('.email-signup-popup__close');
    var nextButtons = ynEmailPopup.querySelectorAll('.email-signup-popup__next');
    var steps = ynEmailPopup.querySelectorAll('.email-signup-popup__step');

    closeButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        ynCloseEmailPopup();
      });
    });

    nextButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        var nextStep = ynEmailPopup.querySelector(`.email-signup-popup__step[data-step="${btn.dataset.next}"]`);
        if (nextStep) {
          var thisForm = btn.closest('form');
          if (thisForm) {
            if (!(thisForm.checkValidity())) {
              return false;
            } else {
              sessionStorage.setItem('ynEmailPopupClosed', 'true');
            }
          }
          steps.forEach((step) => {
            step.classList.add('hide');
          });
          nextStep.classList.remove('hide');
          nextStep.classList.add('fade-in');
          var focusable = nextStep.querySelectorAll('button, [href], input, select, textarea');
          if (focusable[0]) {
            focusable[0].focus();
          }
        } else {
          ynCloseEmailPopup();
        }
      });
    });
  }

  function klaviyoSubscribe(options, callback) {
    fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${window.klaviyoPublicKey}`, options)
    .then(response => response.text())
    .then(response => callback(response))
    .catch(err => console.error(err));
  }

  function klaviyoSubscribeBody(email, subscriptionId, sewing = '', knitting = '', crochet = '') {
    if(isNull(subscriptionId, 'klaviyoBackInStockBody', 'subscriptionId')
      || isNull(email, 'klaviyoBackInStockBody', 'email')
    ) {
      return '';
    }

    let properties = {};

    if(sewing) {
      properties["sewing"] = sewing;
    }

    if(knitting) {
      properties["knitting"] = knitting;
    }

    if(crochet) {
      properties["crochet"] = crochet;
    }

    let fetchBody = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {list: {data: {type: 'list', id: subscriptionId}}}
      }
    }

    if (properties != null) {
      fetchBody.data.attributes.profile.data.attributes['properties'] = properties;
    }

    return fetchBody;
  }

  function submitKlaviyoForm(form, callback) {
    // Convert form data to a URL-encoded string
    var formData = Object.fromEntries(new FormData(form));

    const options = {
      method: 'POST',
      headers: klaviyoPostHeaders(),
      body: JSON.stringify(klaviyoSubscribeBody(formData.email, formData.g, formData.sewing, formData.knitting, formData.crochet))
    };

    klaviyoSubscribe(options, callback);
  }

  if(Shopify.designMode){
    window.addEventListener('shopify:section:load', (e) => {
      if(e.detail.sectionId == "component-email-signup-popup"){
        ynEmailPopup = document.getElementById('email-signup-popup');
        if(ynEmailPopup !== null){
          if(ynEmailPopup.dataset.edit == 'true'){
            ynOpenEmailPopup();
            return;
          }
        }
      }
    });
  }

  if(!window.ynEmailPopupEnabled || window.theme.customer.accepts_marketing || sessionStorage.getItem('ynEmailPopupClosed') === 'true'){
    return;
  }

  var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  var hasScrolled = false;
  var fetchedPopup = false;

  function fetchPopup(){
    fetch('/?view=email-signup-popup').then(response => response.text()).then((data) => {
      const parser = new DOMParser();
      const html = parser.parseFromString(data,'text/html');
      const sectionNode = html.querySelector('.shopify-section');
      document.body.appendChild(sectionNode);
      fetchedPopup = true;
      ynOpenEmailPopup();
    });
  }

  var minScroll = Math.min((document.documentElement.scrollHeight * 0.33),1000);
  window.addEventListener('scroll',() => {
    var st = window.pageYOffset || document.documentElement.scrollTop;

    if (window.scrollY >= minScroll) {
      hasScrolled = true;
    }

    if (st === 0 && hasScrolled) {
      if (!fetchedPopup){
        fetchPopup();
      } else if (ynEmailPopup !== null && sessionStorage.getItem('ynEmailPopupClosed') !== 'true') {
        ynOpenEmailPopup();
      }
    }

    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  }, false);
});



// Level 3 nav item toggles
document.addEventListener('DOMContentLoaded', () => {

  const toggles = document.querySelectorAll('.menu-item-toggle');

  toggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      if (window.innerWidth <= 1024) {
        const level2 = toggle.nextElementSibling;
        if (level2.classList.contains('second-level')) {
          const arrowDown = toggle.querySelector('.arrow-down-svg');
          const arrowUp = toggle.querySelector('.arrow-up-svg');
          arrowDown.classList.toggle('hide');
          arrowUp.classList.toggle('hide');
          // Toggle the display of the .level-2 element
          level2.style.display = level2.style.display === 'block' ? '' : 'block';
        }
      }
    });
  });

  // Menu open / close toggle
  const menuToggle = document.querySelector('.menu-toggle');
  const menuClose = document.querySelector('.close-menu');
  const navigation = document.querySelector('.mobile-navigation');
  const headerBannerWrapper = document.querySelector('.header-banner--wrapper');

  menuToggle.addEventListener('click', function() {
    navigation.classList.toggle('show-mobile-nav');
    // Set the z-index on the header banner wrapper to 1 so that it is rendered behind the mobile nav menu
    if (headerBannerWrapper) {
      headerBannerWrapper.style.zIndex = 1;
    }
    menuClose.focus();
    // Disabling scroll on the body element while menu is open
    document.body.style.overflow = 'hidden';
  });

  menuClose.addEventListener('click', function() {
    navigation.classList.toggle('show-mobile-nav');
    // Reset the z-index on the header banner wrapper to 30 when mobile nav menu is closed
    if (headerBannerWrapper) {
      headerBannerWrapper.style.zIndex = 30;
    }
    menuToggle.focus();
    document.body.style.overflow = 'auto';
  });

  // Level 3 nav item toggles
  const iconPlusElements = document.querySelectorAll('.icon-plus');

  iconPlusElements.forEach(iconPlus => {
    iconPlus.addEventListener('click', () => {
      const level3 = iconPlus.parentElement.nextElementSibling;
      const parentLink = iconPlus.parentElement.previousElementSibling;
      if (level3) {
        parentLink.classList.toggle('bold');
        level3.classList.toggle('show');
        iconPlus.classList.toggle('hide');
        iconPlus.nextElementSibling.classList.toggle('hide');
      }
    });
  });

  const iconMinusElements = document.querySelectorAll('.icon-minus');

  iconMinusElements.forEach(iconMinus => {
    iconMinus.addEventListener('click', () => {
      console.log('test123')
      const level3 = iconMinus.parentElement.nextElementSibling;
      const parentLink = iconMinus.parentElement.previousElementSibling;

      if (level3) {
        parentLink.classList.toggle('bold');
        level3.classList.toggle('show');

        iconMinus.classList.toggle('hide');
        iconMinus.previousElementSibling.classList.toggle('hide');
      }
    });
  });

   // Mobile Search toggles
  const searchToggleBtn = document.querySelector('.search-toggle');
  const mobileSearch = document.querySelector('.mobile-search');
  const mobileSearchInput = document.getElementById('search-header-mobile');

  searchToggleBtn.addEventListener('click', function() {
    mobileSearch.classList.toggle('mobile-search-active');
    if (mobileSearch.classList.contains('mobile-search-active')) {
      mobileSearch.style.maxHeight = mobileSearch.scrollHeight + 'px';
      mobileSearchInput.focus();
    } else {
      mobileSearch.style.maxHeight = 0;
    }
  });

  // User Profile toggles
  const userProfileButton = document.querySelector('.user-profile-button');
  const userPanel = document.getElementById('header-account-links');
  const userFirstLink = userPanel.querySelectorAll('a')[0];

  userProfileButton.addEventListener('click', function() {
    userPanel.classList.toggle('user-panel-active');
    if(userPanel.classList.contains('user-panel-active')){
      userPanel.setAttribute('aria-expanded','true');
      userFirstLink.focus();
    } else {
      userPanel.setAttribute('aria-expanded','false');
    }
  });
});

// When the user scrolls the page, execute stickyHeader
var ynHeader = document.getElementById("shopify-section-header");
var ynMainContent = document.getElementById("MainContent");

window.onscroll = function() {stickyHeader()};
window.onresize = function() {stickyHeader()};

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function stickyHeader() {
  const headerBanner = ynHeader.querySelector(".header-banner");
  if (window.pageYOffset > ynHeader.offsetTop) {
    ynHeader.classList.add("sticky");
    headerBanner && headerBanner.classList.add("hide");
    ynMainContent.style.paddingTop = ynHeader.querySelector(".header-global").offsetHeight+"px";
  } else {
    ynHeader.classList.remove("sticky");
    headerBanner && headerBanner.classList.remove("hide");
    ynMainContent.style.paddingTop = "0px";
  }
}

var menu_item_with_dropdown = document.getElementsByClassName("main-menu__item has-dropdown-menu");
var body = document.querySelector("body");
for (i in menu_item_with_dropdown){
  menu_item_with_dropdown[i].onmouseover=function(){body.classList.add("modal-open-overlay");}
  menu_item_with_dropdown[i].onmouseout=function(){body.classList.remove("modal-open-overlay");}
}
var searchbox = document.querySelector('#Search-In-Modal')
var mobilesearchbox = document.querySelector('.mobile-search #Search-In-Modal')
var searchdropdown = document.querySelector('.predictive-search--header')
var mobilesearchdropdown = document.querySelector('.mobile-search .predictive-search--header')
const search = document.querySelector('.search-modal__form')
const mobilesearch = document.querySelector('.mobile-search .search-modal__form')
searchbox.onkeydown = function(){
  setTimeout(function(){
  if(searchbox.value.length >= 3){
    searchdropdown.style.display = "block";
    body.classList.add("search-modal-open-overlay");
    const navigation = document.querySelector('#navigation')
    navigation && (navigation.classList.add('search-modal-open-overlay'))
  }else{
    searchdropdown.style.display = "none";
    body.classList.remove("search-modal-open-overlay");
    const navigation = document.querySelector('#navigation')
    navigation && (navigation.classList.remove('search-modal-open-overlay'))
  }
    }, 200);
};

document.addEventListener('click', event => {
  const isClickInsideSearch = search.contains(event.target)

  if (!isClickInsideSearch) {
    searchdropdown.style.display = "none";
    body.classList.remove("search-modal-open-overlay");
    const navigation = document.querySelector('#navigation')
    navigation && (navigation.classList.remove('search-modal-open-overlay'))
  }
})

mobilesearchbox.onkeydown = function(){
  const navigation = document.querySelector('#navigation')
  setTimeout(function () {
    if(mobilesearchbox.value.length >= 3){
      mobilesearchdropdown.style.display = "block";
      body.classList.add("search-modal-open-overlay");
      navigation && (navigation.classList.add('search-modal-open-overlay'))
    }else{
      mobilesearchdropdown.style.display = "none";
      body.classList.remove("search-modal-open-overlay");
      navigation && (navigation.classList.remove('search-modal-open-overlay'))
    }
  }, 200);
};

document.addEventListener('click', event => {
  const isClickInside = mobilesearch.contains(event.target)
  if (!isClickInside) {
    mobilesearchdropdown.style.display = "none";
    body.classList.remove("search-modal-open-overlay");
  }
})

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

document.addEventListener('DOMContentLoaded', function () {
  const cartButtons = document.querySelectorAll('.header-cart .cart-button');

  if (!cartButtons.length) { return }

  cartButtons.forEach((cartButton) => {
    cartButton.addEventListener('click', function () {
      const cartDrawer = document.querySelector('cart-drawer');
      cartDrawer.open();
    });
  });
});

function cardSwatchClick (e){
  const parentSwatchList = e.closest('.product-card__swatch-list');
  if (parentSwatchList) {
    const activeImg = parentSwatchList.querySelector('img.active');
    if (activeImg) {
      activeImg.classList.remove('active');
    }
  }

  const imgElement = e.querySelector('img');
  if (imgElement) {
    imgElement.classList.toggle('active');
  }

  const productCard = e.closest('.product-card');
  const variantUrl = e.dataset.varianturl;
  let variantImage = e.dataset.variantimage;
  let variantSecondaryImage = e.dataset.variantsecondaryimage;

  if (variantImage) {
    const pos = variantImage.lastIndexOf('.');
    const otherChar = '_300x.';
    variantImage = variantImage.substring(0, pos) + otherChar + variantImage.substring(pos + 1);

    const productImage = productCard.querySelector('.img-wrapper .product_card_link img');
    if (productImage) {
      productImage.setAttribute('srcset', variantImage);
    }

    const productLinks = productCard.querySelectorAll('.product_card_link');
    productLinks.forEach((productLink) => {
      productLink.setAttribute('href', variantUrl);
    });

    if (variantSecondaryImage) {
      const secondaryPos = variantSecondaryImage.lastIndexOf('.');
      const secondarOtherChar = '_300x.';
      variantSecondaryImage = variantSecondaryImage.substring(0, secondaryPos) + secondarOtherChar + variantSecondaryImage.substring(secondaryPos + 1);

      const secondaryProductImage = productCard.querySelector('.img-wrapper .product_card_link img.boost-pfs-filter-product-item-main-image--secondary');
      if (secondaryProductImage) {
        secondaryProductImage.setAttribute('srcset', variantSecondaryImage);
      }
    }
  }
};

//Move change color next to the variant title
function moveChangeColorToTitle() {
  const contrasts = document.querySelectorAll('.items .contrast')
  contrasts.forEach(contrast => {
    const divContrastNameTop = contrast.querySelector('.contrast-name-top');
    const openColorsModal = contrast.nextElementSibling;

    if (divContrastNameTop && openColorsModal?.hasAttribute('data-modal')) {
      divContrastNameTop.appendChild(openColorsModal);
    }
  });
}

function checkOutOfStockInventory() {
  const kitAddToCart = document.querySelector('#add-to-cart');
  const stockMessageIncomplete = document.querySelector('[data-kit-stock-message-incomplete]');
  const stockMessageComplete = document.querySelector('[data-kit-stock-message-complete]');

  const outOfStockInventory = Array.from(document.querySelectorAll('.js-kit .out-of-stock.inventory')).filter((inventory) => !inventory.hasAttribute('hidden'));

  if(!kitAddToCart) {
    return;
  }

  if(outOfStockInventory.length == 0) {
    kitAddToCart.removeAttribute('disabled');

    if (stockMessageIncomplete) {
      stockMessageIncomplete.classList.add('hidden');
    }

    if (stockMessageComplete) {
      stockMessageComplete.classList.remove('hidden');
    }
    
    return;
  }

  if (stockMessageIncomplete) {
    stockMessageIncomplete.classList.remove('hidden');
  }

  if (stockMessageComplete) {
    stockMessageComplete.classList.add('hidden');
  }

  // kitAddToCart.setAttribute('disabled', true);
}

function changeSelectedOptionNameColorModal(el) {
  // Remove selected class on all modal variants
  document.querySelectorAll('img').forEach(img => img.classList.remove('selected-modal-color'));

  // Add focus class to the selected variant on modal
  el.querySelector('img').classList.add('selected-modal-color');

  // Get selected variant information
  const variantId = el.getAttribute('variant-id');
  const variantHandle = el.getAttribute('data-value');
  const variantQuantity = el.getAttribute('variant-stock');
  const variantPrice = el.getAttribute('variant-price') || '';
  const variantPriceWithoutCurrency = variantPrice.replace('$', '');
  const variantImage = el.getAttribute('data-variant-image');
  const isVariantAvailable = el.getAttribute('data-variant-available');

  // Update current option text
  const variantRadiosModal = el.closest('variant-radios-modal');

  if (variantRadiosModal) {
    const currentOption = variantRadiosModal.querySelector('[data-product-current-option]');

    if (currentOption) {
      currentOption.textContent = ': ' + el.getAttribute('data-value');
    }
  }

  // Find modal ID and related elements
  const modalElement = el.closest('.show-color-modal');

  if (modalElement) {
    const modalId = modalElement.getAttribute('data-colors-modal');
    const findedChangeColorString = document.querySelector(`.colors-modal[data-modal="${modalId}"]`);
    if (findedChangeColorString) {
      const fatherElement = document.querySelector(`.contrast[data-index="${modalElement.getAttribute('data-index')}"]`);
      if (fatherElement) {
        const imageToChange = fatherElement.querySelector('.contrast-image img');
        const titleToChange = fatherElement.querySelector('.contrast-name-current-value');
        const swatchToChange = fatherElement.querySelector('.contrast-swatch');
        const subTitleToChange = fatherElement.querySelector('.contrast-name-current');
        const subTitleToChangeText = subTitleToChange ? subTitleToChange.textContent : '';
        const subTitleToChangeNew = subTitleToChangeText.split(',')[0];
        const priceToChange = fatherElement.querySelector('.price-sales');
        const variantIdToChange = fatherElement.querySelector('.contrast-qty');
        const changeColorDataVariant = fatherElement.querySelector('.open-color-modal');
        const patternQuantityInput = fatherElement.querySelector('[data-pattern-quantity-input]');

        const siblingSwatches = modalElement.querySelectorAll('.product__color-label');

        siblingSwatches.forEach((swatch) => swatch.classList.remove('active__option'));

        el.classList.add('active__option');

        // Handle stock availability
        if (isVariantAvailable === 'false') {
          const outOfStock = fatherElement.querySelector('.out-of-stock.inventory');
          const inStock = fatherElement.querySelector('.in-stock.inventory');
          const warningStock = fatherElement.querySelector('.warning-stock.inventory');
          if (outOfStock) outOfStock.removeAttribute('hidden');
          if (inStock) inStock.setAttribute('hidden', true);
          if (warningStock) warningStock.setAttribute('hidden', true);

          if (variantIdToChange) {
            variantIdToChange.value = '0';
            const changeEvent = new Event('change');
            variantIdToChange.dispatchEvent(changeEvent);
          }
        } else {
          const outOfStock = fatherElement.querySelector('.out-of-stock.inventory');
          const inStock = fatherElement.querySelector('.in-stock.inventory');
          const warningStock = fatherElement.querySelector('.warning-stock.inventory');
          if (outOfStock) outOfStock.setAttribute('hidden', true);
          if (inStock) inStock.removeAttribute('hidden');
          if (warningStock) warningStock.setAttribute('hidden', true);
        }

        if (patternQuantityInput) {
          const actionsToChange = fatherElement.querySelector('.contrast-actions');

          if (actionsToChange) {
            const quantityToChange = actionsToChange.querySelector('.quantity-price');

            if (quantityToChange) {
              quantityToChange.classList.toggle('quantity-price--soldout', isVariantAvailable === 'false');
              patternQuantityInput.value = isVariantAvailable === 'false' ? 0 : 1;
              patternQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }

        // Update elements with new values
        if (titleToChange) titleToChange.textContent = variantHandle;
        if (subTitleToChange) subTitleToChange.textContent = subTitleToChangeNew;
        if (priceToChange) {
          priceToChange.textContent = variantPrice;
          priceToChange.setAttribute('data-price', parseFloat(variantPriceWithoutCurrency) * 100);
        }
        if (imageToChange) imageToChange.setAttribute('src', variantImage);

        imageToChange.removeAttribute('srcset');

        if (swatchToChange) {
          swatchToChange.style.backgroundImage = `url(${el.getAttribute('data-variant-swatch')})`;
        }

        if (variantIdToChange) {
          variantIdToChange.setAttribute('data-variant-id', variantId);
          variantIdToChange.setAttribute('max', variantQuantity);
        }
        if (changeColorDataVariant) changeColorDataVariant.setAttribute('data-variant-color', variantHandle);
      }
    }
  }

  checkOutOfStockInventory();

  const colorModal = el.closest('.show-color-modal');
  if (colorModal && typeof colorModal.close === 'function') {
    colorModal.close();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', (event) => {
    if (event.target.classList.contains('open-color-modal')) {
      const clickedVariantColor = event.target.getAttribute('data-variant-color');
      const modals = document.querySelectorAll('.show-color-modal');
      const labels = document.querySelectorAll(`.show-color-modal .product__color-label`);
      const imgToClickOnModal = document.querySelectorAll(`.show-color-modal .product__color-label[data-value="${clickedVariantColor}"] img`);

      // Remove selected class on all modal variants
      document.querySelectorAll('img').forEach(img => img.classList.remove('selected-modal-color'));

      // Add focus class to selected variant on modal
      imgToClickOnModal.forEach(img => img.classList.add('selected-modal-color'));

      // Set active class on label
      labels.forEach((label) => {
        if (label.getAttribute('data-value') === clickedVariantColor) {
          label.classList.add('active__option');
        } else {
          label.classList.remove('active__option');
        }
      });

      // Update grid counts on all modals
      modals.forEach((modal) => {
        const modalLabels = modal.querySelectorAll(`.product__color-label`);
        const modalVariantGrid = modal.querySelector('[data-product-variant-picker-grid]');

        if (!modalVariantGrid) { return; }

        if (modalLabels && modalLabels.length >= 20) {
          modalVariantGrid.classList.add('three-rows');
        } else if (modalLabels && modalLabels.length >= 10) {
          modalVariantGrid.classList.add('two-rows');
        } else {
          modalVariantGrid.classList.remove('two-rows', 'three-rows');
        }
      });

      // Update the current option text
      const currentOption = document.querySelectorAll('.show-color-modal [data-product-current-option]');

      currentOption.forEach((option) => {
        option.textContent = clickedVariantColor;
      });
    }
  });

  document.querySelectorAll('.mobile-modal-close').forEach(closeButton => {
    closeButton.addEventListener('click', () => {
      document.querySelectorAll('.show-color-modal').forEach(modal => {
        modal.removeAttribute('open');
      });
    });
  });

  document.querySelectorAll('.tooltip').forEach(tooltip => {
    tooltip.addEventListener('click', function (event) {
      event.preventDefault();
      const tooltipContent = tooltip.querySelector('.tooltip-content');
      if (tooltipContent) {
        tooltipContent.style.display = tooltipContent.style.display === 'none' || tooltipContent.style.display === '' ? 'block' : 'none';
      }
    });
  });
})

document.addEventListener("DOMContentLoaded", function() {
  var notifyButton = document.querySelector(".notify--button");
  var BISModalClose = document.querySelector(".bis-modal_close");
  var modalWrapper = document.querySelector(".bis-modal__mobile-wrapper");

  function closeBISModal() {
    if (modalWrapper) {
      modalWrapper.classList.remove("active");
    }
  }

  if (notifyButton) {
    notifyButton.addEventListener("click", function() {
    // Check if modal is already active before toggling
      if (!modalWrapper.classList.contains("active")) {
        modalWrapper.classList.add("active");
      }
    });
  }

  if (BISModalClose) {
    BISModalClose.addEventListener("click", closeBISModal);
  }

  document.addEventListener("click", function(event) {
    var targetElement = event.target;
    if (modalWrapper) {
      if (
        !targetElement.closest(".bis-modal__mobile") &&
        modalWrapper.classList.contains("active") &&
        targetElement !== notifyButton // Exclude notifyButton from closing
      ) {
        closeBISModal();
      }
    }
  });

  moveChangeColorToTitle();

  //Move 'change color' in quickview and add click to 'change color'
  document.body.addEventListener('click', function (event) {
    if (!event.target.classList.contains('quick-add__submit')) { return }
    const quickViewModal = setInterval(function () {
      if (document.querySelector('.contrast-name-top')) {
        moveChangeColorToTitle(); // Assuming this is a defined function

        // Open color modal logic
        document.body.addEventListener('click', function (e) {
          if (e.target.classList.contains('.open-color-modal')) {
            const dataModalAttribute = e.getAttribute('data-open-color-modal');
            const modal = document.querySelector(dataModalAttribute);
            if (modal) {
              modal.setAttribute('open', true);
            }
          }
        });

        // Close color modal logic
        document.body.addEventListener('click', function (e) {
          if (e.target.classList.contains('.close-color-modal')) {
            const modal = e.target.closest('.show-color-modal');
            if (modal) {
              modal.setAttribute('open', false);
            }
          }
        });

        // Handle variant color selection inside modal
        document.body.addEventListener('click', function (e) {
          if (event.target.classList.contains('.open-color-modal')) {
            const clickedVariantColor = event.target.getAttribute('data-variant-color');
            const imgToClickOnModal = document.querySelectorAll(`.show-color-modal .product__color-label[data-value="${clickedVariantColor}"] img`);

            // Remove selected class from all modal variants
            document.querySelectorAll('img').forEach(img => img.classList.remove('selected-modal-color'));

            // Add focus class to selected variant
            imgToClickOnModal.forEach(img => img.classList.add('selected-modal-color'));

            // Update current option text
            const currentOption = document.querySelector('[data-product-current-option]');
            if (currentOption) {
              currentOption.textContent = clickedVariantColor;
            }
          }
        });

        // Close all modals when mobile close button is clicked
        document.querySelectorAll('.mobile-modal-close').forEach(closeButton => {
          closeButton.addEventListener('click', function () {
            document.querySelectorAll('.show-color-modal').forEach(modal => {
              modal.removeAttribute('open');
            });
          });
        });

        clearInterval(quickViewModal);
      }
    }, 100);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.banner-block__text').forEach(function (bannerBlockText) {
    const textHeight = bannerBlockText.offsetHeight;
    const rteHeight = bannerBlockText.querySelector('.rte').offsetHeight;
    const showToggler = Boolean(textHeight <= rteHeight);

    const toggler = bannerBlockText.closest('.banner-block__text-section').querySelector('.toggler');
    toggler.style.display = showToggler ? 'inline' : 'none';
  });
});

var geolocationRequested = false;

const scrollListener = function() {
  let activeFocusElement;

  window.removeEventListener('scroll', scrollListener);

  const closeLocationPopup = document.querySelector('.user-location-popup__switch-sites');
  const userLocationPopup = document.getElementById('user-location-popup');
  const switchSites = document.querySelectorAll('.user-location-popup-button');
  const modalCloseBtn = document.querySelector('.user-location-popup__close');
  const popupHide = localStorage.getItem('popupHide');
  const popupLocation = localStorage.getItem('popupLocation');
  const url = window.location.href;
  const storeLocation = document.getElementById('MainContent')?.getAttribute('data-current-location');
  let userLocation;

  if(popupHide && popupLocation == storeLocation) {
    geolocationRequested = true;
    return;
  }

  if(geolocationRequested) {
    return;
  }

  geolocationRequested = true;

  console.log('popupHide', popupHide);
  console.log('popupLocation', popupLocation);
  console.log('storeLocation', storeLocation);

  navigator.geolocation.getCurrentPosition(function(position) {
    showLocationPopup();
  },
  function(error) {
    if ((error.code === error.POSITION_UNAVAILABLE ||
      error.code === error.PERMISSION_DENIED &&
      popupHide == null &&
      url.indexOf('/en-row') === -1) ||
      (popupLocation != null &&
      storeLocation != popupLocation &&
      url.indexOf('/en-row') === -1)){
      activeFocusElement = document.activeElement;
      showLocationPopup();
    }
    else {
      userLocationPopup.remove();
      localStorage.setItem('popupHide', true);
      localStorage.setItem('popupLocation', storeLocation);
    }
  });

  if (closeLocationPopup) {
    closeLocationPopup.addEventListener('click', () => {
      userLocationPopup.remove();
      localStorage.setItem('popupHide', true);
      localStorage.setItem('popupLocation', storeLocation);
    })
  }

  switchSites.forEach(switchSite => {
    switchSite.addEventListener('click', (e) => {
      e.preventDefault();
      const newLocation = switchSite.dataset.location;
      localStorage.setItem('popupHide', true);
      localStorage.setItem('popupLocation', newLocation);
      changeLocation(newLocation);
      generateNewLocationCart(newLocation, function () {
        changeLocation(newLocation);
      });

      if (activeFocusElement) {
        activeFocusElement.focus();
      }
    })
  });

  if (modalCloseBtn) {
    modalCloseBtn.addEventListener('click', () => {
      hideLocationPopup()
    })
  }

  function hideLocationPopup() {
    userLocationPopup.classList.add('hide');

    if (activeFocusElement) {
      activeFocusElement.focus();
    }

    cancelTrappedFocusInModal(userLocationPopup);
  }

  function showLocationPopup() {
    userLocationPopup.classList.remove('hide');

    trapFocusInModal(userLocationPopup);

    switchSites[0].focus();
  }

  function changeLocation(userLocation){
    userLocationPopup.style.display = 'none';
    if(userLocation === 'United States' || userLocation === "US") {
      window.location.href = url.replace('/en-ca','');
    }else if ((userLocation === 'Canada' || userLocation === "CA") && window.location.href.indexOf('/en-ca') === -1) {
      const urlParts = url.split('.com');
      const newURL = urlParts[0] + '.com/en-ca' + urlParts[1];
      window.location.href = newURL;
    }
  }
};

window.addEventListener('scroll', scrollListener);

function getLocationUrl(newLocation) {
  if (newLocation === 'United States') {
    return window.location.hostname;
  }
  return window.location.hostname +  '/en-ca/';
}

function generateNewLocationCart(newLocation, success) {
  success();
  return;
  /*
  $.ajax({
    type: "GET",
    url: '/cart?view=localization',
    success: function(response) {
      const cartItems = JSON.parse(response);

      if(cartItems.length == 0) {
        success();
        return;
      }

      var newBaseUrl = getLocationUrl(newLocation);

      switch (newLocation) {
        case "CA":
        case "Canada":
          updateCartLocation(cartItems, "Bassett DC", newBaseUrl, success);
          break;
        case "US":
        case"United States":
          updateCartLocation(cartItems, "Albany DC", newBaseUrl, success);
          break;
        default:
          clearCart(success);
          return;
      }
    }
  });
  */
}

function updateCartLocation(cartItems, inventory_center, newBaseUrl, success) {
  var updates = {}
  var updatedQuantities = false;
  for(var i = 0; i < cartItems.length; i++) {
    var item = cartItems[i];
    var inventory = item.inventories.find((inventory) => inventory.key === inventory_center);
    updates[`${item.key}`] = item.current_quantity;

    if(!inventory) {
      updates[`${item.key}`] = 0;
      updatedQuantities = true;
    }

    if(inventory.value < item.current_quantity) {
      updates[`${item.key}`] = inventory.value;
      updatedQuantities = true;
    }
  }
  var options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  }
  fetch("/cart/update.js", options)
  .then((response => {
    if(updatedQuantities) {
      window.location.href = "https://" + newBaseUrl + "cart?cartUpdated=true";
      return;
    }
    success();
  }))
}

function clearCart(success, error) {
  sessionStorage.removeItem('gwp-removed');
  $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    data: '',
    dataType: 'json',
    success: success,
    error: error
  });
}

function downloadPattern(el) {
  const patternData = el.dataset.product

  if (!patternData) { return; }

  const patternDataJson = JSON.parse(patternData);
  const dataFields = [
    "id",
    "master_id",
    "name",
    "pattern_name_version",
    "skill_level",
    "skill_type",
    "pattern_category",
    "project_type",
    "pattern_made_for",
    "brand",
    "product_line",
    "seasonal"
  ];

  const eventData = {};

  dataFields.forEach((dataField) => {
    if (patternDataJson[dataField] != null) {
      eventData[dataField] = patternDataJson[dataField];
    }
  });

  if (Object.keys(eventData).length === 0) { return; }

  dataLayer.push({
    event: "patternDownload",
    product: eventData
  });
};

function isNull(item, functionName, itemName) {
  if(!item) {
    console.error(`${functionName} Error: ${itemName} is null`)
    return true;
  }
  return false;
}

function klaviyoSubscribeToBackInStock(options, callback) {
  fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.klaviyoPublicKey}`, options)
  .then(response => response.text())
  .then(response => callback(response))
  .catch(err => console.error(err));
}

function klaviyoBackInStockBody(variantId, email) {
  if(isNull(variantId, 'klaviyoBackInStockBody', 'variantId')
    || isNull(email, 'klaviyoBackInStockBody', 'email')
  ) {
    return '';
  }

  return {
    data: {
      type: 'back-in-stock-subscription',
      attributes: {
        channels: ['EMAIL'],
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: email
            }
          }
        }
      },
      relationships: {
        variant: {
          data: {
            type: 'catalog-variant',
            id: `$shopify:::$default:::${variantId}`
          }
        }
      }
    }
  }
}

function klaviyoPostHeaders() {
  return {
    accept: 'application/json',
    revision: '2024-07-15',
    'content-type': 'application/json'
  }
}

const ynTimerBanner = document.querySelector('.banner-text--timer');
const timerMessage = document.querySelector('[data-timer-message]');
function updateTimer(endDate) {
  const hideTimer = ynTimerBanner.getAttribute('data-hide-timer');
  var now = new Date();
  now = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
  var difference = endDate - now;
  var days = Math.floor(difference / (1000 * 60 * 60 * 24));
  var hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((difference % (1000 * 60)) / 1000);

  var timerDisplay = days + "D " + hours + "H " + minutes + "M " + seconds + "S";
  const timerEl = document.querySelector('.banner-text--timer .metafield-date_time');
  if(timerEl){
    timerEl.innerText = timerDisplay;
  }

  ynTimerBanner.style.display = 'inline';

  if (hideTimer === 'false') {
    if (difference <= 0 && timerEl) {
      timerEl.innerText = "0D 0H 0M 0S";
    }
  } else {
    if (difference <= 0) {
      ynTimerBanner.style.display = 'none';

      if (timerMessage) {
        timerMessage.style.display = 'none';
      }
    } else {
      ynTimerBanner.style.display = 'inline';

      if (timerMessage) {
        timerMessage.style.display = 'inline';
      }
    }
  }

  if (timerMessage && timerMessage.style.opacity !== 1) {
    timerMessage.style.opacity = 1;
  }
}

if(ynTimerBanner){
  var endDateString = ynTimerBanner.textContent;
  var endDate = new Date(endDateString);

  setInterval(function() {
    updateTimer(endDate);
  }, 1000);

  updateTimer(endDate);
} else {
  if (timerMessage) {
    timerMessage.style.opacity = 1;
    timerMessage.style.display = 'inline';
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const desktopSearchInput = document.querySelector('.desktop-search-wrapper .search__input');
  if (desktopSearchInput) {
    desktopSearchInput.addEventListener('click', function () {
      setTimeout(function () {
        desktopSearchInput.focus();
      }, 10);
    });
  }

  const searchToggle = document.querySelector('.search-toggle');
  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      setTimeout(function () {
        const mobileSearchInput = document.querySelector('.mobile-search .search__input');
        if (mobileSearchInput) {
          mobileSearchInput.focus();
        }
      }, 100);
    });
  }

  document.body.addEventListener('click', function (event) {
    if (event.target.classList.contains('open-color-modal')) {
      const dataModalAttribute = event.target.getAttribute('data-open-color-modal');
      if (dataModalAttribute) {
        const modal = document.querySelector(dataModalAttribute);
        if (modal) {
          modal.setAttribute('open', true);
        }
      }
    }
  });

  document.body.addEventListener('click', function (event) {
    if (event.target.classList.contains('close-color-modal')) {
      const modal = event.target.closest('.show-color-modal');
      if (modal) {
        modal.setAttribute('open', false);
      }
    }
  });
})

// AccessibleWeb links fix
document.addEventListener("DOMContentLoaded", () => {
  const accessibilityLinks = document.querySelectorAll('[data-awam-target]');
  accessibilityLinks.forEach((accessibilityLink) => {
    accessibilityLink.addEventListener('click', (event) => {
      if (accessibilityLink.hasAttribute('tabindex')) {
        return;
      }
      event.preventDefault();
      const widgetLoadedLink = document.querySelector('[data-awam-target][tabindex]');
      if (widgetLoadedLink) {
        widgetLoadedLink.click();
      }
    });
  });
})

const focusableElementsInModal = (modal) => {
  if (!modal) { return }
  return Array.from(
    modal.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])')
  )
  .filter(element => element.checkVisibility ? element.checkVisibility() : true );
}

const trapFocusInModal = (modal) => {
  const firstFocusableEl = focusableElementsInModal(modal)[0];
  firstFocusableEl.focus();

  const KEYCODE_TAB = 9;

  // when we hit tab or shift-tab, if we select an element outside the modal, then force-select an element INSIDE the modal
  modal.keydownlistener = function(e) {
    const focusableElements = focusableElementsInModal(modal);

    if (e.key === 'Tab' || e.keyCode === KEYCODE_TAB) {
      if ( e.shiftKey ) /* shift + tab */ {
        if (document.activeElement == focusableElements[0] || !focusableElements.includes(document.activeElement)) {
          focusableElements[focusableElements.length - 1].focus();

          e.preventDefault();
        }
      } else /* tab */ {
        if (document.activeElement == focusableElements[focusableElements.length - 1] || !focusableElements.includes(document.activeElement)) {
          focusableElements[0].focus();

          e.preventDefault();
        }
      }
    }
  };

  document.addEventListener('keydown', modal.keydownlistener);
}

const cancelTrappedFocusInModal = (modal) => {
  document.removeEventListener('keydown', modal.keydownlistener);
}


class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId,this.dataset.sectionId);
  }

  initializeRecommendations(productId,sectionId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .then((text) =>{
    const swiperRoot = document.getElementById('swiper-'+this.dataset.sectionId);
    const options = {
                keyboard: true,
                observer: true,
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: false,
                navigation: {
                    prevEl: '#swiper-container-'+this.dataset.sectionId+' .product-carousel__prev',
                    nextEl: '#swiper-container-'+this.dataset.sectionId+' .product-carousel__next'
                },
                pagination: {
                    el: '#swiper-container-'+this.dataset.sectionId+' .product-carousel__pagination',
                    type: 'bullets',
                    clickable: true,
                    bulletClass: 'product-carousel__pagination-bullet'
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        slidesPerGroup: 2
                    },
                    1024: {
                        slidesPerView: 3,
                        slidesPerGroup: 3
                    }
                },
                on: {
                    init: function(swiper){
                        var arrowBtns = swiper.el.querySelectorAll('.product-carousel__arrow');
                        arrowBtns.forEach((btn)=>{btn.setAttribute('aria-disabled','false')});
                    }
                }
            }

            var swiper = new Swiper(swiperRoot, options);
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/* ================================================
  Trapfocus (a11y)
================================================== */

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) { return; }

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') { return; }

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) {
    elementToFocus.focus();
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
